import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ashtavinayakdarshancab() {



const cardData = {
  keyword: " Ashtavinayak Darshan Cab ",

"headingDescription": "Ashtavinayak Darshan Cab service offers a comfortable, reliable, and spiritually enriching journey for devotees visiting the eight sacred Ganpati temples of Maharashtra. Perfect for religious trips, family tours, and group travel, our professional drivers and well-maintained vehicles ensure a smooth and well-organized pilgrimage experience. We provide customized Ashtavinayak Darshan packages with one-way and round trip options, transparent pricing, and no hidden charges. With SRS Ashtavinayak Darshan Cab, enjoy easy booking, 24/7 support, and a peaceful journey covering all eight holy temples in a proper sequence.",
"topPlaces": [
  {
    "title": "Moreshwar Temple (Morgaon)",
    "description": "Moreshwar Temple in Morgaon is considered the starting and ending point of the Ashtavinayak Yatra. Devotees booking Ashtavinayak Darshan Cab begin their spiritual journey here with prayers to Lord Ganesha."
  },
  {
    "title": "Siddhivinayak Temple (Siddhatek)",
    "description": "Siddhivinayak Temple at Siddhatek is known for fulfilling wishes and holds great religious importance. Travelers using Ashtavinayak Darshan Cab visit this temple to seek divine blessings and success."
  },
  {
    "title": "Ballaleshwar Temple (Pali)",
    "description": "Ballaleshwar Temple in Pali is the only temple named after a devotee of Lord Ganesha. Visitors traveling via Ashtavinayak Darshan Cab explore its unique history and spiritual significance."
  },
  {
    "title": "Varadvinayak Temple (Mahad)",
    "description": "Varadvinayak Temple at Mahad is known as the wish-fulfilling Ganpati. Devotees using Ashtavinayak Darshan Cab often visit this temple to pray for prosperity and happiness."
  },
  {
    "title": "Chintamani Temple (Theur)",
    "description": "Chintamani Temple in Theur is associated with removing worries and granting peace of mind. Travelers booking Ashtavinayak Darshan Cab come here to find spiritual calm and blessings."
  },
  {
    "title": "Girijatmaj Temple (Lenyadri)",
    "description": "Girijatmaj Temple at Lenyadri is located inside a cave and requires climbing several steps. Visitors using Ashtavinayak Darshan Cab experience devotion along with scenic hill surroundings."
  },
  {
    "title": "Vighnahar Temple (Ozar)",
    "description": "Vighnahar Temple in Ozar is believed to remove all obstacles from life. Travelers using Ashtavinayak Darshan Cab visit this temple for success, peace, and positive energy."
  },
  {
    "title": "Mahaganpati Temple (Ranjangaon)",
    "description": "Mahaganpati Temple at Ranjangaon is known for its powerful idol of Lord Ganesha. Devotees completing their Ashtavinayak Darshan Cab journey visit this temple before returning to Morgaon."
  }
],



services: [
{
name: "Cab for Ashtavinayak Darshan",
description: "Cab for Ashtavinayak darshan offers comfortable travel for visiting all eight Ganpati temples. Customers can book cabs for one-day or two-day trips. Professional drivers ensure smooth and safe journeys. Comfortable vehicles enhance pilgrimage experience. Flexible travel options are available. Travel easily with Ashtavinayak cab services from Pune."
},
{
name: "Ashtavinayak Darshan Package from Pune",
description: "Ashtavinayak darshan package from Pune provides complete tour solutions for devotees. Customers can choose customized packages for temple visits. Comfortable vehicles ensure smooth travel across routes. Professional drivers ensure safe journeys. Transparent pricing ensures affordability. Book Ashtavinayak packages from Pune easily."
},
{
name: "Ashtavinayak Darshan from Pune in 2 Days",
description: "Ashtavinayak darshan from Pune in 2 days offers a planned itinerary for temple visits. Customers can cover all temples comfortably in two days. Professional drivers ensure smooth travel. Comfortable vehicles enhance journey experience. Flexible booking options are available. Complete your darshan easily from Pune."
},
{
name: "Pune to Ashtavinayak Taxi Service",
description: "Pune to Ashtavinayak taxi service provides reliable transportation for pilgrimage trips. Customers can book taxis for full darshan tours. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel conveniently with taxi services from Pune."
},
{
name: "Pune to Ashtavinayak Tour Package",
description: "Pune to Ashtavinayak tour package offers organized travel plans for devotees. Customers can enjoy complete temple visits with ease. Comfortable vehicles ensure smooth travel. Professional drivers ensure safe journeys. Transparent pricing ensures value for money. Choose tour packages for Ashtavinayak darshan."
},
{
name: "Pune to Ashtavinayak Darshan Package",
description: "Pune to Ashtavinayak darshan package provides complete travel solutions for pilgrims. Customers can visit all temples with planned routes. Comfortable vehicles enhance travel experience. Professional drivers ensure safe journeys. Flexible booking options are available. Book darshan packages easily from Pune."
},
{
name: "Cheapest Ashtavinayak Tour from Pune",
description: "Cheapest Ashtavinayak tour from Pune offers budget-friendly travel options. Customers can complete darshan at economical prices. Comfortable vehicles ensure smooth journeys. Professional drivers ensure safe travel. Transparent pricing ensures affordability. Travel economically for Ashtavinayak darshan from Pune."
},
{
name: "Cheapest Tempo Traveller for Ashtavinayak Tour from Pune",
description: "Cheapest tempo traveller for Ashtavinayak tour from Pune offers group travel at affordable rates. Customers can book spacious vehicles for families and groups. Professional drivers ensure safe journeys. Comfortable seating enhances travel experience. Flexible booking options are available. Travel together with tempo traveller services."
},
{
name: "Pune to Ashtavinayak Cab",
description: "Pune to Ashtavinayak cab provides convenient travel for temple visits. Customers can book cabs for one-day or multi-day trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily with Pune to Ashtavinayak cab services."
},
{
name: "Ashtavinayak Yatra Tour Cabs",
description: "Ashtavinayak yatra tour cabs offer dedicated transportation for pilgrimage tours. Customers can complete temple visits with ease. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible travel options are available. Choose yatra cabs for Ashtavinayak darshan trips."
},
{
name: "Pune to Ashtavinayak Tempo Traveller on Rent",
description: "Pune to Ashtavinayak tempo traveller on rent offers group travel solutions. Customers can book spacious vehicles for family trips. Professional drivers ensure safe journeys. Comfortable seating enhances long travel experience. Flexible booking options are available. Travel together with tempo traveller rentals."
},
{
name: "Pune to Ashtavinayak Mini Bus on Rent",
description: "Pune to Ashtavinayak mini bus on rent provides large group travel options. Customers can book buses for pilgrimage tours. Professional drivers ensure safe journeys. Comfortable seating enhances travel experience. Transparent pricing ensures affordability. Travel in groups with mini bus rentals."
},
{
name: "Pune to Ashtavinayak 17 Seater Bus on Rent",
description: "Pune to Ashtavinayak 17 seater bus on rent offers comfortable group travel. Customers can book buses for family and tour groups. Professional drivers ensure safe journeys. Spacious seating enhances comfort. Flexible booking options are available. Travel easily with 17 seater bus rentals."
},
{
name: "Pune to Ashtavinayak Ertiga on Rent",
description: "Pune to Ashtavinayak Ertiga on rent offers comfortable 7-seater travel. Customers can enjoy spacious rides for family trips. Professional drivers ensure safe journeys. Comfortable seating enhances travel experience. Transparent pricing ensures affordability. Travel with Ertiga rentals for Ashtavinayak darshan."
},
{
name: "Ashtavinayak Tour from Pune by Car Package",
description: "Ashtavinayak tour from Pune by car package offers personalized travel plans. Customers can visit all temples with private vehicles. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily with car packages from Pune."
},
{
name: "Pune to Ashtavinayak Innova Crysta on Rent",
description: "Pune to Ashtavinayak Innova Crysta on rent offers premium SUV travel. Customers can enjoy spacious and comfortable journeys. Professional drivers ensure safe travel. Ideal for family trips. Transparent pricing ensures value for money. Travel comfortably with Innova Crysta services."
},
{
name: "Pune to Ashtavinayak Taxi Fare",
description: "Pune to Ashtavinayak taxi fare provides pricing details for pilgrimage trips. Customers can check fare estimates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with taxi fare services."
},
{
name: "Ashtavinayak Darshan Cab from Pune",
description: "Ashtavinayak darshan cab from Pune offers reliable travel for temple visits. Customers can book cabs for full darshan trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel conveniently with cab services."
},
{
name: "Pune to Ashtavinayak Darshan Cab",
description: "Pune to Ashtavinayak darshan cab provides easy travel for pilgrimage tours. Customers can book cabs for temple visits. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with darshan cab services."
},
{
name: "Ashtavinayak Darshan Taxi Pune",
description: "Ashtavinayak darshan taxi Pune offers convenient travel for devotees. Customers can book taxis for full yatra trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Choose taxi services for Ashtavinayak darshan."
},
{
name: "Pune Ashtavinayak Cab Service",
description: "Pune Ashtavinayak cab service provides reliable transportation for temple visits. Customers can book cabs for one-day or multi-day tours. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel conveniently with cab services from Pune."
},
{
name: "Ashtavinayak Tour Cab from Pune",
description: "Ashtavinayak tour cab from Pune offers comfortable travel for pilgrimage tours. Customers can book cabs for visiting all temples. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily with tour cab services."
},
{
name: "Ashtavinayak Darshan Cab Booking Pune",
description: "Ashtavinayak darshan cab booking Pune provides quick and easy reservation options. Customers can book cabs online or via phone. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your darshan cab easily from Pune."
},
{
name: "Ashtavinayak Taxi Booking Pune",
description: "Ashtavinayak taxi booking Pune offers simple and convenient booking services. Customers can reserve taxis instantly for pilgrimage trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Transparent pricing ensures affordability. Book your Ashtavinayak taxi easily from Pune."
}
],

tableData: [
["Cab for Ashtavinayak Darshan","Ashtavinayak Darshan Package from Pune"],
["Ashtavinayak Darshan from Pune in 2 Days","Pune to Ashtavinayak Taxi Service"],
["Pune to Ashtavinayak Tour Package","Pune to Ashtavinayak Darshan Package"],
["Cheapest Ashtavinayak Tour from Pune","Cheapest Tempo Traveller for Ashtavinayak Tour from Pune"],
["Pune to Ashtavinayak Cab","Ashtavinayak Yatra Tour Cabs"],
["Pune to Ashtavinayak Tempo Traveller on Rent","Pune to Ashtavinayak Mini Bus on Rent"],
["Pune to Ashtavinayak 17 Seater Bus on Rent","Pune to Ashtavinayak Ertiga on Rent"],
["Ashtavinayak Tour from Pune by Car Package","Pune to Ashtavinayak Innova Crysta on Rent"],
["Pune to Ashtavinayak Taxi Fare","Ashtavinayak Darshan Cab from Pune"],
["Pune to Ashtavinayak Darshan Cab","Ashtavinayak Darshan Taxi Pune"],
["Pune Ashtavinayak Cab Service","Ashtavinayak Tour Cab from Pune"],
["Ashtavinayak Darshan Cab Booking Pune","Ashtavinayak Taxi Booking Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Ashtavinayak Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides experienced drivers who are well familiar with all Ashtavinayak temple routes, ensuring smooth travel across multiple destinations with proper darshan planning."
  },
  {
    WhyChooseheading: "Affordable Ashtavinayak Darshan Cab Packages",
    WhyChoosedescription: "We offer budget-friendly Ashtavinayak Darshan cab services with transparent pricing. Customers get complete package details with no hidden charges for a stress-free pilgrimage."
  },
  {
    WhyChooseheading: "Well-Planned Darshan Itinerary",
    WhyChoosedescription: "SRS Cab Service provides optimized travel routes covering all 8 Ashtavinayak temples including Morgaon, Siddhatek, Pali, Mahad, Theur, Lenyadri, Ozar, and Ranjangaon for efficient darshan."
  },
  {
    WhyChooseheading: "24/7 Cab Service for Pilgrimage Travel",
    WhyChoosedescription: "Our Ashtavinayak Darshan cab service operates 24/7, making it convenient for early morning departures, multi-day tours, and flexible travel plans."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Tours",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles designed for long-distance temple tours, ensuring a peaceful and comfortable journey."
  },
  {
    WhyChooseheading: "Flexible 1 Day & 2 Day Tour Packages",
    WhyChoosedescription: "Choose from 1-day express darshan or 2-day relaxed tour packages based on your convenience, including customized plans for families and groups."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers suitable for family and group pilgrimage travel."
  },
  {
    WhyChooseheading: "Trusted Ashtavinayak Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Ashtavinayak Darshan cab bookings due to reliable service, experienced drivers, and smooth pilgrimage travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Ashtavinayak Darshan cab service?", answer: "Yes, SRS Cab Service offers reliable cab services for Ashtavinayak Darshan from Pune." },
  { question: "Which temples are included in Ashtavinayak Darshan?", answer: "The tour includes 8 temples: Morgaon, Siddhatek, Pali, Mahad, Theur, Lenyadri, Ozar, and Ranjangaon." },
  { question: "How many days are required for Ashtavinayak Darshan?", answer: "You can complete the darshan in 1 day (fast trip) or 2 days (comfortable tour)." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for pilgrimage travel." },
  { question: "Which vehicles are available for Ashtavinayak tour?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I customize my Ashtavinayak tour?", answer: "Yes, we provide fully customizable travel plans based on your schedule." },
  { question: "Are vehicles suitable for long-distance travel?", answer: "Yes, all vehicles are well-maintained and suitable for long-distance temple tours." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Ashtavinayak Darshan cab service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ganesh Patil",
    feedback:
      "Booked SRS Cab Service for Ashtavinayak Darshan. Very well-planned trip and driver guided us perfectly.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sunita Kulkarni",
    feedback:
      "Excellent Ashtavinayak cab service. Comfortable journey and smooth darshan experience.",
    rating: 5
  }
];

































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];















const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ashtavinayak Darshan Cab | SRS Cab",
  "description": "SRS Cab offers Ashtavinayak Darshan cab services and tour packages from Pune including one-way and round trips, tempo travellers, mini buses, 17-seater buses, Innova Crysta, and Ertiga on rent. Book safe, comfortable, and affordable cabs for your Ashtavinayak Yatra with 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};




  return (
    <div>
      

<Helmet>
  <title>Ashtavinayak Darshan Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Ashtavinayak Darshan cabs from Pune with SRS Cab. One-way, round trips, tempo travellers, mini buses, 17-seater buses, Innova Crysta & Ertiga on rent. Safe, comfortable, and affordable Ashtavinayak Yatra cab services with 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ashtavinayakdarshancab;